import { AlertTriangle, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EMAIL, PHONE, PHONE_RAW, SITE_NAME } from '../../constants/site';

export default function BookingTechnicalIssue() {
  const tel = PHONE_RAW.replace(/[^\d+]/g, '') || PHONE.replace(/[^\d+]/g, '');

  return (
    <div className="booking-issue" role="alert">
      <div className="booking-issue__icon" aria-hidden>
        <AlertTriangle size={48} />
      </div>
      <h2>We are facing a technical issue</h2>
      <p>
        Your booking could not be completed online at this time. Our team has received your details
        and will assist you shortly. Please contact {SITE_NAME} to confirm your reservation.
      </p>
      <div className="booking-issue__contact">
        <a href={`tel:${tel}`} className="booking-issue__link">
          <Phone size={18} aria-hidden />
          {PHONE}
        </a>
        <a href={`mailto:${EMAIL}`} className="booking-issue__link">
          <Mail size={18} aria-hidden />
          {EMAIL}
        </a>
      </div>
      <div className="booking-issue__actions">
        <Link to="/flight/support" className="btn-gold">
          Contact support
        </Link>
        <Link to="/flight" className="btn-outline booking-issue__btn-outline">
          Back to home
        </Link>
      </div>
    </div>
  );
}
